import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getBookingWidgetMultipropertyData = createAsyncThunk(
    'booking-widget/get-multiproperty-data',
    async (params = {}) => {
        let url = params.multipropertyUrl;

        const sortByProperty = params.sortByProperty || '';
        let urlParts = url.split('&');

        // When sortBy is provided replace the sort query parameter with the
        // one selected by the user
        if (sortByProperty) {
            urlParts = urlParts.map((urlPart) => {
                if (urlPart.startsWith('sort')) {
                    return `sort=${sortByProperty}`;
                } else {
                    return urlPart;
                }
            });

            url = urlParts.join('&');
        }

        const queryParams = {};

        const response = await axios.get(url, { params: queryParams });
        return response.data;
    }
);

export const bookingWidgetMultipropertySlice = createSlice({
    name: 'multiproperty',
    initialState: {
        multipropertyProperties: [],
        multipropertyCount: 0,
        multipropertyOptions: [],
        selectedRoom: null,
        selectedRoomIndex: null,
        isDrawerOpen: false,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
        multipropertyDropdown: [],
        markers: [],
        selectedPropertyId: null,
        filteredProperties: null,
        isMobileFiltersOpen: false,
        isMobileSearchOptionsOpen: false,
        isMobileDetailsOpen: false,
    },
    reducers: {
        updateMultiPropertyChannel: (state, action) => {
            const channelID = action.payload.channelId;
            const price = action.payload.price;
            for (let i = 0; i < state?.multipropertyProperties?.length; i++) {
                let channelIndex = -1;
                const property = state?.multipropertyProperties[i];
                if (channelIndex === -1) {
                    channelIndex = property.channels.findIndex(
                        (channel) => channel.channelID === channelID
                    );
                }

                if (channelIndex !== -1) {
                    // There is no price remove the channel
                    // eslint-disable-next-line no-useless-escape
                    if (
                        property.channels !== undefined &&
                        property.channels.length !== 0
                    ) {
                        if (
                            !price ||
                            price === 0 ||
                            /^0*[.,]?0*$/.test(price)
                        ) {
                            state.multipropertyProperties[i].channels =
                                property.channels.filter(
                                    (channel) => channel.channelID !== channelID
                                );

                            if (
                                state.filteredProperties &&
                                state.filteredProperties[i]
                            ) {
                                state.filteredProperties[i].channels =
                                    property.channels.filter(
                                        (channel) =>
                                            channel.channelID !== channelID
                                    );
                            }
                        } else {
                            state.multipropertyProperties[i].channels[
                                channelIndex
                            ].price = price;

                            if (
                                state.filteredProperties &&
                                state.filteredProperties[i]
                            ) {
                                state.filteredProperties[i].channels[
                                    channelIndex
                                ].price = price;
                            }
                        }
                    }
                }
            }

            // filtered properties
            for (let i = 0; i < state?.filteredProperties?.length; i++) {
                let channelIndex = -1;
                const property = state?.filteredProperties[i];
                if (channelIndex === -1) {
                    channelIndex = property.channels.findIndex(
                        (channel) => channel.channelID === channelID
                    );
                }

                if (channelIndex !== -1) {
                    // There is no price remove the channel
                    // eslint-disable-next-line no-useless-escape
                    if (
                        property.channels !== undefined &&
                        property.channels.length !== 0
                    ) {
                        if (
                            !price ||
                            price === 0 ||
                            /^0*[.,]?0*$/.test(price)
                        ) {
                            state.filteredProperties[i].channels =
                                property.channels.filter(
                                    (channel) => channel.channelID !== channelID
                                );
                        } else {
                            state.filteredProperties[i].channels[
                                channelIndex
                            ].price = price;
                        }
                    }
                }
            }
        },
        setSelectedPropertyId: (state, action) => {
            state.selectedPropertyId = action.payload.selectedPropertyId;
        },
        setFilteredProperties: (state, action) => {
            state.filteredProperties = action.payload.filteredProperties;
        },
        setOpenFilters: (state, action) => {
            state.isMobileFiltersOpen = action.payload.isMobileFiltersOpen;
        },
        setMobileSearchOptions: (state, action) => {
            state.isMobileSearchOptionsOpen =
                action.payload.isMobileSearchOptionsOpen;
        },
        setMobileDetailsOpen: (state, action) => {
            state.isMobileDetailsOpen = action.payload.isMobileDetailsOpen;
        },
    },
    extraReducers: {
        [getBookingWidgetMultipropertyData.fulfilled]: (state, { payload }) => {
            state.multipropertyProperties = payload.multiproperty || [];
            state.multipropertyOptions = payload.multipropertyOptions || [];
            state.multipropertyDropdown = payload.multipropertyDropdown || [];
            state.markers = payload.markers || [];
            state.multipropertyCount =
                payload.multipropertyOptions?.multiPropertyCount || 0;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.errorMessage = '';
        },
        [getBookingWidgetMultipropertyData.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.errorMessage = '';
        },
        [getBookingWidgetMultipropertyData.pending]: (state) => {
            state.isFetching = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },
});

export const {
    updateMultiPropertyChannel,
    setSelectedPropertyId,
    setFilteredProperties,
    setOpenFilters,
    setMobileSearchOptions,
    setMobileDetailsOpen,
} = bookingWidgetMultipropertySlice.actions;
